const branch = localStorage.getItem("branch");
export const StockDataColumns = branch
  ? [
      {
        id: "date",
        title: "Date",
        minWidth: 100,
        align: "center",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "itemId",
        title: "Item Name",
        minWidth: 200,
      },
      {
        id: "invoice_no",
        title: "Invoice",
        minWidth: 100,
        align: "left",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "truck_no",
        title: "Truck",
        minWidth: 100,
        align: "left",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "desc",
        title: "Description",
        minWidth: 100,
        align: "center",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "purchase",
        title: "Purchase",
        minWidth: 100,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "qty",
        title: "Qty",
        minWidth: 110,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "total_amount",
        title: "Total",
        minWidth: 80,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
    ]
  : [
      {
        id: "date",
        title: "Date",
        minWidth: 100,
        align: "center",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "name",
        title: "Item Name",
        minWidth: 200,
      },
      {
        id: "invoice_no",
        title: "Invoice",
        minWidth: 100,
        align: "left",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "truck_no",
        title: "Truck",
        minWidth: 100,
        align: "left",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "branch",
        title: "Branch #",
        minWidth: 100,
        align: "center",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "desc",
        title: "Description",
        minWidth: 100,
        align: "center",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "purchase",
        title: "Purchase",
        minWidth: 100,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "qty",
        title: "Qty",
        minWidth: 110,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "total_amount",
        title: "Total",
        minWidth: 80,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
    ];
